import React from 'react';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import { togglePosesBackgroundsSelector } from '../../../../../../reducers/productConfigSlice';
import { productNeedsBackgroundSelection } from '../../../productConfigPredicates';
import { backgroundSlotsCount, productPosesCount } from '../../../imageRecords';
import BackgroundSlot from './BackgroundSlot';
import PoseSlot from './PoseSlot';

const SelectedConfigWrapper = styled.div`
  display: flex;
  justify-content: center;
  position: relative;
  z-index: 2;
  &:hover {
    cursor: pointer;
  }
`;

const BackgroundPosesContainer = () => {
  const dispatch = useDispatch();
  const product = useSelector(
    (state: any) => state.productConfig.currentProduct,
  );

  // Poses and backgrounds are independent totals (a product may have more of
  // one than the other), so we render `max(poses, backgrounds)` rows, pairing a
  // pose slot with a background slot by index where each exists.
  //
  // Background tiles only draw when the product actually needs a background
  // picked — a background-skipped digital download (all_backgrounds /
  // no_background) still reports a positive slot count, so the raw count
  // alone can't be trusted (ENG-2300); productNeedsBackgroundSelection
  // covers that, while poses configure normally.
  const posesCount = productPosesCount(product);
  const productBackgroundSlotsCount = productNeedsBackgroundSelection(product)
    ? backgroundSlotsCount(product)
    : 0;
  const rowCount = Math.max(posesCount, productBackgroundSlotsCount);

  return (
    <>
      {Array.from({ length: rowCount }, (_unused, i) => (
        <SelectedConfigWrapper
          key={`selected-config-${i}`}
          onClick={() => (dispatch as any)(togglePosesBackgroundsSelector())}
        >
          {i < posesCount && (
            <PoseSlot index={i} showLabel={i === posesCount - 1} />
          )}
          {i < productBackgroundSlotsCount && (
            <BackgroundSlot
              index={i}
              showLabel={i === productBackgroundSlotsCount - 1}
            />
          )}
        </SelectedConfigWrapper>
      ))}
    </>
  );
};

export default BackgroundPosesContainer;
